import React from 'react';
import { SwitchInputV2Type, SwitchInputV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { SwitchFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormSwitchInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
  SwitchInputV2Type {
  fieldMeta: SwitchFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormSwitchInputV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormSwitchInputV2Props<TFormFields>) => {
  const { onChange, value, ...otherFieldMeta } = fieldMeta;

  return (
    <FormInputController<TFormFields>
      name={name}
      fieldMeta={{
        ...fieldMeta,
        required: false,
      }}
      renderInput={({ onChange: onControllerChange, ...controllerProps }) => (
        <SwitchInputV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          onChange={(...event) => {
            onControllerChange(...event);

            fieldMeta.onChange && fieldMeta.onChange(...event);
          }}
          {...controllerProps}
          {...props}
          {...otherFieldMeta}
        />
      )}
      {...{
        ...props,
        rules: {
          validate: fieldMeta.required ? (value) => {
            if (value == null) {
              return "This field is required"
            }
            return true
          } : undefined,
          ...props.rules,
        }
      }}

    />
  );
};
